<script>
export default {};
</script>

<template>
	<a
		class="logo-box"
		href="https://www.bmw.com.tw/zh/index.html"
		target="_blank"
		v-sendGAsignal="{
			event_type: 'click',
			event_category: 'CI',
			event_label: 'homepage',
		}"
	>
		<div class="logo-img">
			<img src="~@/assets/BMW-logo.svg" alt="BMW logo" />
		</div>
		<div class="logo-text text_ch_medium">總代理 汎德</div>
	</a>
</template>

<style lang="sass" scoped>
.logo-box
	position: fixed
	display: flex
	flex-direction: column
	justify-content: center
	align-items: center
	top: calc(2.6vw + 9.8px)
	left: calc(4.6vw - 2.8px)
	z-index: 610
	text-decoration: none
	user-select: none
	cursor: pointer
	.logo-img
		// width: calc(1.8vw + 26.1px)
		// height: calc(1.8vw + 26.1px)
		width: 3.125vw
		height: 3.125vw
		min-width: 33px
		min-height: 33px
		border-radius: 50%
	.logo-text
		font-size: 1.4rem
		line-height: 3.21
		letter-spacing: -0.7px
		text-align: center
@media screen and (max-width: 1200px)
	.logo-box
		// transform: scale(0.8)
		// transform-origin: left top
		// top: 3vw
		// left: 4.43vw
@media screen and (max-width: 768px)
	.logo-box
		// transform: scale(1)
		.logo-img
			width: calc(1.8vw + 26.1px)
			height: calc(1.8vw + 26.1px)
		.logo-text
			font-size: 1rem
			line-height: 3.29
			letter-spacing: -0.35px
			transform: scale(0.7)
			transform-origin: center top
</style>
